const NONCE_MIN_ENTROPY_BITS = 128;

export const NONCE_ENTROPY_BYTES = Math.ceil(NONCE_MIN_ENTROPY_BITS / 8);
